import React from "react";
import Modal from "components/utils/Modal";
import { useTranslation } from "react-i18next";
import TelButton from "components/utils/TelButton";
import EmailButton from "components/utils/EmailButton";

type Props = {
	isOpen: boolean
	toggleModalOpen: () => void
}

function ContactModal({
	isOpen,
	toggleModalOpen,
}: Props) {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={ isOpen }
			toggleModalOpen={ toggleModalOpen }
		>
			<div className="text-center flex flex-col gap-10 sm:gap-16 bg-white">
				<div className="text-neutral-950 text-xl sm:text-2xl md:text-3xl font-semibold">
					{ t(`contactModal.title`) }
				</div>
				<p className="text-black sm:text-base md:text-xl font-normal">
					{ t(`contactModal.text`) }
				</p>
				<div className="flex gap-6 items-center justify-center">
					<TelButton>
						{ t(`contactModal.callButton`) }
					</TelButton>
					<span className="text-gray-900 text-xl font-normal hidden sm:block">
						{ t(`contactModal.buttonsMiddleText`) }
					</span>
					<EmailButton>
						{ t(`contactModal.emailButton`) }
					</EmailButton>
				</div>
			</div>
		</Modal>
	);
}

export default ContactModal;